module.exports = __webpack_public_path__ + "static/img/application6-4.71ce5bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application6-4.jpg
// module id = VqOp
// module chunks = 0